import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const KEY = "lss-cart";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const add = (item) => {
      const id = `${item.lookup_key}|${item.flavor || ""}`;
      setItems((prev) => {
        const found = prev.find((i) => i.id === id);
        if (found) return prev.map((i) => (i.id === id ? { ...i, qty: Math.min(100, i.qty + item.qty) } : i));
        return [...prev, { ...item, id }];
      });
      setOpen(true);
    };
    const setQty = (id, qty) =>
      setItems((prev) => (qty < 1 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty } : i))));
    const clear = () => setItems([]);
    const count = items.reduce((s, i) => s + i.qty, 0);
    const subtotal = items.reduce((s, i) => s + i.qty * i.price, 0);
    return { items, add, setQty, clear, count, subtotal, open, setOpen };
  }, [items, open]);

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
};

export const useCart = () => useContext(CartCtx);
